import { CreditCard } from "data/shared/CreditCard";
import { useCallback, useState } from "react";
import { Modal } from "./design-system/Modal";

export const CardComboTemplates = ({
  setSelection,
  selectedCards
}: {
  setSelection: (_: CreditCard[]) => void
  selectedCards: CreditCard[]
}) => {
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<CreditCard[]>([]);

  const handleTemplateClick = useCallback((template: CreditCard[]) => {
    if (selectedCards?.length) {
      setShowWarningModal(true);
      setSelectedTemplate(template);
    } else {
      setSelection(template);
    }
  }, [selectedCards, setSelection]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: 5,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <p style={{ margin: 0 }}>Recommended card combos:</p>
      <button
        onClick={() =>
          handleTemplateClick([
            CreditCard.CHASE_FREEDOM_FLEX_CREDIT_CARD,
            CreditCard.CHASE_FREEDOM_UNLIMITED_CREDIT_CARD,
            CreditCard.CHASE_SAPPHIRE_PREFERRED_CREDIT_CARD,
          ])
        }
      >
        Chase Trifecta
      </button>
      <button
        onClick={() =>
          handleTemplateClick([
            CreditCard.AMERICAN_EXPRESS_GOLD_CARD,
            CreditCard.THE_PLATINUM_CARD,
            // CreditCard.,
          ])
        }
      >
        American Express Trifecta
      </button>
      <button
        onClick={() =>
          handleTemplateClick([
            CreditCard.CITI_DOUBLE_CASH_CARD,
            CreditCard.CITI_STRATA_PREMIER_CARD,
            CreditCard.CITI_CUSTOM_CASH_CARD,
          ])
        }
      >
        Citi cash back combo
      </button>
      <Modal
        isOpen={showWarningModal}
        handleClose={() => {
          setShowWarningModal(false);
          setSelectedTemplate([]);
        }}
        cancelText="Cancel"
        extraFooterButtons={
          <button
            style={{
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              marginTop: 8,
            }}
            onClick={() => {
              setSelection(selectedTemplate);
              setShowWarningModal(false);
              setSelectedTemplate([]);
            }}
          >
            Ok
          </button>
        }
      >
        <h2>Replace current cards?</h2>
        <p>You already have cards selected. Selecting a new card combo will replace the current cards.</p>
      </Modal>
    </div>
  );
}